// Candados de edición de un retailer integrado: qué escrituras bloquea el back y cuáles quedan libres.
import { ApiError } from '@/api/errors';
import type { Retailer } from '@fiado/type-kit/bin/retailOrg/dtos/Retailer';
import { RetailIntegrationModeEnum } from '@fiado/type-kit/bin/retailOrg/enums/RetailIntegrationModeEnum';
import type { BackofficeUpdateProductRequest } from '@/api/services/retail-catalog/backoffice';

export const ENTITY_MANAGED_BY_INTEGRATION = 'ENTITY_MANAGED_BY_INTEGRATION';

/** Campos de un producto que Fiado sigue editando en un retailer integrado. */
const FREE_PRODUCT_FIELDS = [
    'tier',
    'eligibleFinanciers',
    'mdmEnabled',
    'mdmProvider',
    'mdmLockMode',
] as const satisfies readonly (keyof BackofficeUpdateProductRequest)[];

export function isIntegratedRetailer(
    retailer: Pick<Retailer, 'integrationSystem'> | null | undefined,
): boolean {
    return Boolean(retailer?.integrationSystem);
}

/** Modo vigente de una cadena integrada; sin modo guardado es FULL, igual que en retail-org. */
export function integrationModeOf(
    retailer: Pick<Retailer, 'integrationSystem' | 'integrationMode'> | null | undefined,
): RetailIntegrationModeEnum | null {
    if (!isIntegratedRetailer(retailer)) return null;
    return retailer?.integrationMode ?? RetailIntegrationModeEnum.FULL;
}

export function isManagedByIntegrationError(error: unknown): boolean {
    return error instanceof ApiError && error.code === ENTITY_MANAGED_BY_INTEGRATION;
}

/** Kits y servicios son de Fiado: el candado no los toca. Acepta el tipo del catálogo o de la fila. */
export function isIntegrationFreeKind(kind: string): boolean {
    return kind === 'KIT' || kind === 'SERVICE';
}

/** El patch de un producto integrado, reducido a gama, financieras y MDM. */
export function toIntegratedProductPatch(
    patch: BackofficeUpdateProductRequest,
): BackofficeUpdateProductRequest {
    const free: BackofficeUpdateProductRequest = {};
    for (const key of FREE_PRODUCT_FIELDS) {
        if (key in patch) Object.assign(free, { [key]: patch[key] });
    }
    return free;
}
